const clients = require('../config/index').config;

export const get_default_avatar = () =>
    `${clients.minio}/doitforme/morning/app/boiler/DefaultAvatar.jpg`;

const INITIALS_COLORS = [
    ['#0EA5A4', '#99F6E4'],
    ['#2563EB', '#BFDBFE'],
    ['#DC2626', '#FECACA'],
    ['#7C3AED', '#DDD6FE'],
    ['#EA580C', '#FED7AA'],
    ['#059669', '#A7F3D0'],
    ['#DB2777', '#FBCFE8'],
    ['#0891B2', '#BAE6FD'],
];

const escape_xml = (value = '') =>
    String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');

const get_user_initials = (resolvedUser = {}) => {
    const firstname = resolvedUser?.firstname?.trim?.() || '';
    const lastname = resolvedUser?.lastname?.trim?.() || '';
    const username = resolvedUser?.username?.trim?.() || '';

    if (firstname || lastname) {
        return `${firstname[0] || ''}${lastname[0] || ''}`.toUpperCase();
    }

    const usernameParts = username
        .replace(/[@+._-]+/g, ' ')
        .split(' ')
        .filter(Boolean);

    if (usernameParts.length >= 2) {
        return `${usernameParts[0][0]}${usernameParts[1][0]}`.toUpperCase();
    }

    if (usernameParts.length === 1) {
        return usernameParts[0].slice(0, 2).toUpperCase();
    }

    return '?';
};

const hash_string = (value = '') => {
    let hash = 0;
    for (let i = 0; i < value.length; i += 1) {
        hash = value.charCodeAt(i) + ((hash << 5) - hash);
    }
    return Math.abs(hash);
};

export const get_generated_avatar = ({ user, userId } = {}) => {
    const resolvedUser = user?.user ? user.user : user || {};
    const seed = `${userId || resolvedUser?.sub || resolvedUser?.userId || ''}:${resolvedUser?.username || ''}:${resolvedUser?.firstname || ''}:${resolvedUser?.lastname || ''}`;
    const [primaryColor, secondaryColor] =
        INITIALS_COLORS[hash_string(seed) % INITIALS_COLORS.length];
    const initials = escape_xml(get_user_initials(resolvedUser));

    const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160">
            <defs>
                <linearGradient id="avatarGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stop-color="${primaryColor}" />
                    <stop offset="100%" stop-color="${secondaryColor}" />
                </linearGradient>
            </defs>
            <rect width="160" height="160" rx="80" fill="url(#avatarGradient)" />
            <circle cx="80" cy="80" r="68" fill="rgba(255,255,255,0.14)" />
            <text
                x="50%"
                y="54%"
                text-anchor="middle"
                dominant-baseline="middle"
                fill="#ffffff"
                font-family="Arial, Helvetica, sans-serif"
                font-size="56"
                font-weight="700"
                letter-spacing="1"
            >
                ${initials}
            </text>
        </svg>
    `.trim();

    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};

export const get_user_avatar_src = ({
    user,
    userId,
    imageVersion,
    profileAvatar,
}) => {
    const resolvedUser = user?.user ? user.user : user || {};
    const resolvedProfileAvatar =
        profileAvatar ?? resolvedUser?.profileAvatar ?? '';
    const resolvedAvatarState = resolvedUser?.images?.avatar;
    const resolvedUserId = userId ?? resolvedUser?.sub ?? resolvedUser?.userId;
    const resolvedUpdatedAt = resolvedUser?.updatedAt
        ? new Date(resolvedUser.updatedAt).getTime()
        : '';

    if (resolvedAvatarState === 'set' && resolvedUserId) {
        const version = imageVersion || resolvedUpdatedAt;
        return `${clients.minio}/erisedev/${resolvedUserId}/avatar.png${
            version ? `?v=${version}` : ''
        }`;
    }

    if (resolvedProfileAvatar) {
        return `${clients.minio}/doitforme/morning/profileAvatars/${resolvedProfileAvatar}.png`;
    }

    return get_generated_avatar({ user: resolvedUser, userId: resolvedUserId });
};
